import rootStore from "@/app/store";
import { LandlordUser } from "../businessProfiles";
import crud, { ApiResponse } from "../crud";

export interface AdminPermission {
  id: number;
  name: string;
  display_name: string;
  bit: number;
}

export function LandlordsAPI(baseUrl: string) {
  return {
    listPermissions: async () => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/landlords/permissions/?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<AdminPermission[]>;
    },
    getAdminById: async (id: number) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/landlords/${id}/?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<LandlordUser>;
    },
    getAdminPermissionsById: async (id: number) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/landlords/${id}/permissions/?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<number>;
    },
    updateAdminPermissionsById: async (id: number, permissions: number[]) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.put(
        `${baseUrl}/landlords/${id}/permissions/?business_profile_id=${businessProfileId}`,
        { permissions },
        true,
      )) as ApiResponse<LandlordUser>;
    },
    unlinkAdminFromBussinessProfile: async (id: number) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.delete(
        `${baseUrl}/landlords/${id}?business_profile_id=${businessProfileId}`,
        true,
      )) as ApiResponse<LandlordUser>;
    },
  };
}
